import {Pipe, PipeTransform} from "@angular/core";
import {PostalAddress} from '@app/_model';

@Pipe({
  name: 'postalAddressText',
  standalone: true
})
export class PostalAddressTextPipe implements PipeTransform {
  public transform(postalAddress: PostalAddress | undefined | null): string {
    if (!postalAddress) {
      return "";
    }
    let retval: string = "";
    if (postalAddress.zip) {
      if (!postalAddress.state && !postalAddress.city && !postalAddress.area) {
        retval += "(" + postalAddress.zip + ")";
      } else {
        retval += " " + postalAddress.zip;
      }
    }
    if (postalAddress.state) {
      retval += " " + postalAddress.state;
    }
    if (postalAddress.city) {
      retval += " " + postalAddress.city;
    }
    if (postalAddress.area) {
      retval += " " + postalAddress.area;
    }
    if (postalAddress.state || postalAddress.city || postalAddress.area) {
      retval += ",";
    }
    if (postalAddress.publicPlace) {
      retval += " " + postalAddress.publicPlace;
    }
    if (postalAddress.publicPlaceType) {
      retval += " " + postalAddress.publicPlaceType;
    }
    if (postalAddress.buildingName) {
      retval += " " + postalAddress.buildingName;
    }
    if (postalAddress.number) {
      retval += " " + postalAddress.number;
    }
    if (postalAddress.other) {
      retval += " " + postalAddress.other;
    }
    if (postalAddress.country) {
      if (postalAddress.country != "Magyarország") {
        retval += " (" + postalAddress.country + ")";
      }
    }
    return retval.trim();
  }
}
